import Icon from '../../../components/AppIcon';

const JobDescription = ({ job }) => {
  return (
    <div className="bg-card rounded-lg border border-border p-6 lg:p-8">
      <h2 className="text-2xl font-bold text-foreground mb-6 flex items-center gap-2">
        <Icon name="FileText" size={24} className="text-primary" />
        Job Description
      </h2>
      <div className="prose prose-sm sm:prose max-w-none">
        <div className="text-foreground leading-relaxed whitespace-pre-line mb-8">
          {job?.description}
        </div>

        <div className="mb-8">
          <h3 className="text-xl font-semibold text-foreground mb-4 flex items-center gap-2">
            <Icon name="Target" size={20} className="text-primary" />
            Key Responsibilities
          </h3>
          <ul className="space-y-3">
            {job?.responsibilities?.map((responsibility, index) => (
              <li key={index} className="flex items-start gap-3">
                <Icon name="CheckCircle2" size={18} className="text-success flex-shrink-0 mt-0.5" />
                <span className="text-foreground">{responsibility}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="mb-8">
          <h3 className="text-xl font-semibold text-foreground mb-4 flex items-center gap-2">
            <Icon name="Award" size={20} className="text-primary" />
            Required Qualifications
          </h3>
          <ul className="space-y-3">
            {job?.qualifications?.map((qualification, index) => (
              <li key={index} className="flex items-start gap-3">
                <Icon name="CheckCircle2" size={18} className="text-success flex-shrink-0 mt-0.5" />
                <span className="text-foreground">{qualification}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="mb-8">
          <h3 className="text-xl font-semibold text-foreground mb-4 flex items-center gap-2">
            <Icon name="Sparkles" size={20} className="text-primary" />
            Preferred Skills
          </h3>
          <div className="flex flex-wrap gap-2">
            {job?.preferredSkills?.map((skill, index) => (
              <span
                key={index}
                className="px-3 py-1.5 bg-primary/10 text-primary text-sm font-medium rounded-full"
              >
                {skill}
              </span>
            ))}
          </div>
        </div>

        {job?.benefits && job?.benefits?.length > 0 && (
          <div className="mb-8">
            <h3 className="text-xl font-semibold text-foreground mb-4 flex items-center gap-2">
              <Icon name="Gift" size={20} className="text-primary" />
              Benefits & Perks
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {job?.benefits?.map((benefit, index) => (
                <div key={index} className="flex items-center gap-3 p-3 bg-muted rounded-lg">
                  <Icon name="Check" size={18} className="text-success flex-shrink-0" />
                  <span className="text-foreground text-sm">{benefit}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        {job?.reportingStructure && (
          <div className="p-4 bg-muted rounded-lg">
            <h4 className="text-sm font-semibold text-foreground mb-2 flex items-center gap-2">
              <Icon name="Users" size={16} className="text-primary" />
              Reporting Structure
            </h4>
            <p className="text-sm text-muted-foreground">{job?.reportingStructure}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default JobDescription;